import { getAbTestLifecycleState } from '@bridebook/toolbox/src/ab-testing/lib/selectors';
import { useABTestV2Integration } from '@bridebook/web/lib/ab-tests/hooks/use-ab-test-v2-integration';
import { getVariant_AiWeddingPlanner } from '@bridebook/web/lib/ab-tests/tests/global/LIVE-28398_AiWeddingPlanner';
import { isAiWeddingPlannerVariantEnabled } from '@bridebook/web/lib/ai-planner/availability';
import type { IApplicationState } from '@bridebook/web/lib/types';
import { useSelector } from '@bridebook/web/lib/utils';

const testId = 'LIVE-29320_FullstoryAiWeddingPlanner';

export const getVariant_FullstoryAiWeddingPlanner = (state: IApplicationState) =>
  getAbTestLifecycleState(state, testId)?.variant;

// Variant 1 is recorded; control, and a cohort still resolving, are not
export const getIsFullstoryAiWeddingPlannerSampled = (state: IApplicationState) =>
  getVariant_FullstoryAiWeddingPlanner(state) === '1';

/**
 * Samples couples in a planner cohort for FullStory recording, keeping sessions within
 * the plan quota. The planner cohort is the trigger: control is skipped, and nobody is
 * allocated while the planner test is still resolving.
 */
export const useABTest_FullstoryAiWeddingPlanner = () => {
  const plannerVariant = useSelector(getVariant_AiWeddingPlanner);
  // Undefined keeps the sample waiting until the planner cohort is known
  const hasPlanner = plannerVariant ? isAiWeddingPlannerVariantEnabled(plannerVariant) : undefined;

  useABTestV2Integration({ testId, triggerCondition: hasPlanner });
};
